import React, { Component } from 'react'

export default class FooterComponent extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="footer-container">
            <div className="list-footer">
              <h4 className="list__title">GetTrip.Guru</h4>
              <ul className="list-unstyled">
                <li>
                  <a href="#">Homepage</a>
                </li>
                <li>
                  <a href="#">Guided activitie</a>
                </li>
                <li>
                  <a href="#">Expert's tailored tours</a>
                </li>
              </ul>
            </div>
            <div className="list-footer">
              <h4 className="list__title">Become a Guide</h4>
              <ul className="list-unstyled">
                <li>
                  <a href="#">Become a Tour Expert</a>
                </li>
                <li>
                  <a href="#">Become an Activity Guide</a>
                </li>
              </ul>
            </div>
            <div className="list-footer md-only">
              <h4 className="list__title">Info</h4>
              <ul className="list-unstyled">
                <li>
                  <a href="#">About us</a>
                </li>
                <li>
                  <a href="#">Careers</a>
                </li>
                <li>
                  <a href="#">Help</a>
                </li>
                <li>
                  <a href="#">Trust & Safety</a>
                </li>
              </ul>
            </div>
            <div className="list-footer md-only">
              <ul className="list list-unstyled items-footer">
                <li className="item-footer__select">
                  <select className="form-control item-footer__language">
                    <option>English</option>
                    <option>Deutsche</option>
                  </select>
                </li>
                <li className="item-footer__select">
                  <select className="form-control item-footer__currency">
                    <option>USD</option>
                    <option>EURO</option>
                  </select>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-copyright">
            <div className="footer-copyright__soc">
              <ul className="soc-list list-unstyled">
                <li className="soc-item soc-facebook">
                  <a href="#"> </a>
                </li>
                <li className="soc-item soc-instagram">
                  <a href="#"> </a>
                </li>
                <li className="soc-item soc-twitter">
                  <a href="#"> </a>
                </li>
              </ul>
            </div>
            <div className="footer-copyright__copy">&copy; Trippere</div>
          </div>
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// src/components/homepage/FooterComponent.js